window.modals = {
    _openModal(modalId, contentId) {
        var modal = document.getElementById(modalId);
        var content = document.getElementById(contentId);
        if (!modal) return;
        modal.setAttribute("aria-hidden", "false");

        // Force a reflow so the browser has a painted frame at opacity-0 to
        // transition FROM. This used to be a requestAnimationFrame, but rAF does
        // not fire while the tab is backgrounded - and because pointer-events was
        // re-enabled OUTSIDE that callback, a modal opened on a hidden tab stayed
        // fully transparent while already absorbing every click on the page. The
        // result was a page that looked normal but where no link or button worked.
        void modal.offsetWidth;

        modal.classList.remove("opacity-0");
        modal.classList.add("opacity-100");
        if (content) {
            content.classList.remove("scale-95");
            content.classList.add("scale-100");
            if (content.classList.contains("-rotate-6")) {
                content.classList.remove("-rotate-6");
                content.classList.add("rotate-0");
            }
        }

        // Only start intercepting clicks once the overlay is actually on screen.
        modal.classList.remove("pointer-events-none");
    },

    _closeModal(modalId, contentId, callback) {
        var modal = document.getElementById(modalId);
        var content = document.getElementById(contentId);
        if (!modal) return;
        modal.classList.remove("opacity-100");
        modal.classList.add("opacity-0");
        if (content) {
            content.classList.remove("scale-100");
            content.classList.add("scale-95");
        }
        setTimeout(function () {
            modal.classList.add("pointer-events-none");
            modal.setAttribute("aria-hidden", "true");
            if (callback) callback();
        }, 300);
    },

    // Subscribe Modal (early access + 10% off)
    _subscribeFlavor: null,

    openSubscribe(flavorName) {
        this._subscribeFlavor = flavorName || null;

        var flavorNote = document.getElementById("subscribe-flavor-note");
        var flavorNameEl = document.getElementById("subscribe-flavor-name");
        if (flavorNote && flavorNameEl) {
            if (this._subscribeFlavor) {
                flavorNameEl.textContent = this._subscribeFlavor;
                flavorNote.classList.remove("hidden");
            } else {
                flavorNote.classList.add("hidden");
            }
        }

        var formSection = document.getElementById("subscribe-form-section");
        var successSection = document.getElementById("subscribe-success-section");
        var errorEl = document.getElementById("subscribe-error");
        var emailInput = document.getElementById("subscribe-email");
        var btn = document.getElementById("subscribe-submit-btn");

        if (!formSection || !successSection || !errorEl || !btn) return;

        formSection.classList.remove("hidden");
        successSection.classList.add("hidden");
        errorEl.classList.add("hidden");
        if (emailInput) emailInput.value = "";
        btn.textContent = "Get My 10% Off";
        btn.disabled = false;
        this._openModal("subscribe-modal", "subscribe-modal-content");
        this._toggleSubscribeFab(false);
    },

    openPresale(flavorName) {
        this.openSubscribe(flavorName);
    },

    closeSubscribe() {
        this._markSubscribeSeen();
        this._closeModal("subscribe-modal", "subscribe-modal-content");
        this._toggleSubscribeFab(true);
    },

    _toggleSubscribeFab(show) {
        var fab = document.getElementById("subscribe-fab");
        if (!fab) return;
        fab.classList.toggle("subscribe-fab--hidden", !show);
    },

    _markSubscribeSeen() {
        try {
            sessionStorage.setItem("subscribe-modal-seen", "true");
        } catch (e) {}
    },

    resetSubscribePopup() {
        try {
            sessionStorage.removeItem("subscribe-modal-seen");
        } catch (e) {}
        if (window.__subscribePopupTimer) {
            clearTimeout(window.__subscribePopupTimer);
            window.__subscribePopupTimer = null;
        }
        window.__subscribePopupInit = false;
        initSubscribeAutoPopup();
    },

    handleSubscribeSubmit(e) {
        e.preventDefault();
        var self = this;
        var email = document.getElementById("subscribe-email").value.trim();
        var errorEl = document.getElementById("subscribe-error");
        var errorText = document.getElementById("subscribe-error-text");
        var btn = document.getElementById("subscribe-submit-btn");

        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            errorEl.classList.remove("hidden");
            errorText.textContent = "Please enter a valid email address";
            return false;
        }

        errorEl.classList.add("hidden");
        btn.textContent = "Subscribing...";
        btn.disabled = true;

        var settings = window.chewteinzSettings || {};
        var listId = settings.klaviyoSubscribeListId;

        if (!listId) {
            errorEl.classList.remove("hidden");
            errorText.textContent =
                "Newsletter signup is not configured. Please contact the store owner.";
            btn.textContent = "Get My 10% Off";
            btn.disabled = false;
            return false;
        }

        var formBody =
            "g=" +
            encodeURIComponent(listId) +
            "&email=" +
            encodeURIComponent(email.toLowerCase());

        var source = "Subscribe modal (10% off)";
        if (self._subscribeFlavor) {
            source =
                "Early access & 10% off: " + self._subscribeFlavor;
            formBody +=
                "&$fields=" +
                encodeURIComponent("$source,presale_product") +
                "&presale_product=" +
                encodeURIComponent(self._subscribeFlavor);
        }

        formBody += "&$source=" + encodeURIComponent(source);

        fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formBody,
        })
            .then(function (res) {
                if (!res.ok) {
                    return res.json().then(function (data) {
                        var msg =
                            (data.errors &&
                                data.errors[0] &&
                                data.errors[0].detail) ||
                            "Failed to subscribe";
                        throw new Error(msg);
                    });
                }
                document
                    .getElementById("subscribe-form-section")
                    .classList.add("hidden");
                document
                    .getElementById("subscribe-success-section")
                    .classList.remove("hidden");
                setTimeout(function () {
                    self._markSubscribeSeen();
                    self._toggleSubscribeFab(true);
                    self._closeModal(
                        "subscribe-modal",
                        "subscribe-modal-content",
                        function () {
                            self.openGift();
                        },
                    );
                }, 1500);
            })
            .catch(function (err) {
                errorEl.classList.remove("hidden");
                errorText.textContent =
                    err.message || "Something went wrong. Please try again.";
                btn.textContent = "Get My 10% Off";
                btn.disabled = false;
            });

        return false;
    },

    // Gift Modal
    openGift() {
        this._openModal("gift-modal", "gift-modal-content");
        document.getElementById("gift-copy-icon").classList.remove("hidden");
        document.getElementById("gift-check-icon").classList.add("hidden");
        document.getElementById("gift-copied-msg").classList.add("hidden");
        this._showConfetti();
    },

    closeGift() {
        this._closeModal("gift-modal", "gift-modal-content");
    },

    copyGiftCode() {
        var self = this;
        try {
            navigator.clipboard.writeText("CHEWFAN10").then(function () {
                self._showCopied();
            });
        } catch (e) {
            var ta = document.createElement("textarea");
            ta.value = "CHEWFAN10";
            document.body.appendChild(ta);
            ta.select();
            document.execCommand("copy");
            document.body.removeChild(ta);
            self._showCopied();
        }
    },

    _showCopied() {
        document.getElementById("gift-copy-icon").classList.add("hidden");
        document.getElementById("gift-check-icon").classList.remove("hidden");
        document.getElementById("gift-copied-msg").classList.remove("hidden");
        setTimeout(function () {
            document
                .getElementById("gift-copy-icon")
                .classList.remove("hidden");
            document.getElementById("gift-check-icon").classList.add("hidden");
            document.getElementById("gift-copied-msg").classList.add("hidden");
        }, 2000);
    },

    _showConfetti() {
        var container = document.getElementById("confetti-container");
        if (!container) return;
        container.classList.remove("hidden");
        var colors = [
            "#FFD700",
            "#FF1493",
            "#9B59B6",
            "#00CED1",
            "#FF6347",
            "#32CD32",
        ];
        var html = "";
        for (var i = 0; i < 50; i++) {
            var left = Math.random() * 100;
            var delay = Math.random() * 0.5;
            var dur = 2 + Math.random() * 2;
            var color = colors[Math.floor(Math.random() * colors.length)];
            var rot = Math.random() * 360;
            html +=
                '<div class="absolute -top-4 w-2 h-2 opacity-0 animate-confetti-fall" style="left:' +
                left +
                "%;background-color:" +
                color +
                ";animation-delay:" +
                delay +
                "s;animation-duration:" +
                dur +
                "s;transform:rotate(" +
                rot +
                'deg)"></div>';
        }
        container.innerHTML = html;
        setTimeout(function () {
            container.classList.add("hidden");
            container.innerHTML = "";
        }, 4000);
    },

    // Nutrition Modal
    openNutrition(productName, imageSrc, imageAlt) {
        var label = document.getElementById("nutrition-product-name");
        if (label) {
            label.textContent = productName || "";
        }

        // Swap in this flavour's panel; fall back to the packaged default so a
        // product without its own panel never shows another flavour's numbers.
        var image = document.getElementById("nutrition-info-image");
        if (image) {
            var defaultSrc =
                image.getAttribute("data-default-src") || image.src;
            var defaultAlt =
                image.getAttribute("data-default-alt") || image.alt;
            image.src = imageSrc || defaultSrc;
            image.alt = imageAlt || defaultAlt;
        }

        this._openModal("nutrition-modal", "nutrition-modal-content");
    },

    closeNutrition() {
        this._closeModal("nutrition-modal", "nutrition-modal-content");
    },

    // Notify Modal
    openNotify(flavorName) {
        document.getElementById("notify-flavor-name").textContent = flavorName;
        document
            .getElementById("notify-form-section")
            .classList.remove("hidden");
        document
            .getElementById("notify-success-section")
            .classList.add("hidden");
        document.getElementById("notify-error").classList.add("hidden");
        document.getElementById("notify-name").value = "";
        document.getElementById("notify-email").value = "";
        document.getElementById("notify-submit-btn").textContent = "Notify Me";
        document.getElementById("notify-submit-btn").disabled = false;
        document.getElementById("notify-success-text").textContent =
            "We'll email you as soon as " + flavorName + " is available.";
        this._openModal("notify-modal", "notify-modal-content");
    },

    closeNotify() {
        this._closeModal("notify-modal", "notify-modal-content");
    },

    handleNotifySubmit(e) {
        e.preventDefault();
        var name = document.getElementById("notify-name").value.trim();
        var email = document.getElementById("notify-email").value.trim();
        var errorEl = document.getElementById("notify-error");
        var errorText = document.getElementById("notify-error-text");
        var btn = document.getElementById("notify-submit-btn");
        var flavorName =
            document.getElementById("notify-flavor-name").textContent.trim() ||
            "this product";

        if (!name) {
            errorEl.classList.remove("hidden");
            errorText.textContent = "Please enter your name";
            return false;
        }
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            errorEl.classList.remove("hidden");
            errorText.textContent = "Please enter a valid email address";
            return false;
        }

        errorEl.classList.add("hidden");
        btn.textContent = "Submitting...";
        btn.disabled = true;

        var settings = window.chewteinzSettings || {};
        var listId =
            settings.klaviyoNotifyListId || settings.klaviyoSubscribeListId;

        if (!listId) {
            errorEl.classList.remove("hidden");
            errorText.textContent =
                "Back-in-stock signup is not configured. Please contact the store owner.";
            btn.textContent = "Notify Me";
            btn.disabled = false;
            return false;
        }

        var formBody =
            "g=" +
            encodeURIComponent(listId) +
            "&email=" +
            encodeURIComponent(email.toLowerCase()) +
            "&$first_name=" +
            encodeURIComponent(name) +
            "&$source=" +
            encodeURIComponent("Back-in-stock notify: " + flavorName) +
            "&$fields=" +
            encodeURIComponent("$first_name,$source,notify_product") +
            "&notify_product=" +
            encodeURIComponent(flavorName);

        fetch("https://manage.kmail-lists.com/ajax/subscriptions/subscribe", {
            method: "POST",
            headers: {
                "Content-Type": "application/x-www-form-urlencoded",
            },
            body: formBody,
        })
            .then(function (res) {
                if (!res.ok) {
                    return res.json().then(function (data) {
                        var msg =
                            (data.errors &&
                                data.errors[0] &&
                                data.errors[0].detail) ||
                            "Failed to sign up";
                        if (msg.toLowerCase().indexOf("already") !== -1)
                            msg = "You're already on the list!";
                        throw new Error(msg);
                    });
                }
                document
                    .getElementById("notify-form-section")
                    .classList.add("hidden");
                document
                    .getElementById("notify-success-section")
                    .classList.remove("hidden");
            })
            .catch(function (err) {
                errorEl.classList.remove("hidden");
                errorText.textContent =
                    err.message || "Something went wrong. Please try again.";
                btn.textContent = "Notify Me";
                btn.disabled = false;
            });

        return false;
    },

    // Preorder Modal
    openPreorder() {
        this._openModal("preorder-modal", "preorder-modal-content");
    },

    closePreorder() {
        this._closeModal("preorder-modal", "preorder-modal-content");
    },
};

// Nutrition modal: delegated clicks avoid inline onclick (CSP-safe) and work with hero when link is blank or '#'.
document.addEventListener(
    "click",
    function (e) {
        var trigger = e.target.closest("[data-open-nutrition]");
        if (!trigger) return;
        e.preventDefault();
        var name = trigger.getAttribute("data-product-name");
        if (name === null || name === undefined) name = "";
        var src = trigger.getAttribute("data-nutrition-src") || "";
        var alt = trigger.getAttribute("data-nutrition-alt") || "";
        if (
            window.modals &&
            typeof window.modals.openNutrition === "function"
        ) {
            window.modals.openNutrition(name, src, alt);
        }
    },
    false,
);

// Auto-show subscribe modal once per session (after dismiss or signup)
function initSubscribeAutoPopup() {
    if (window.__subscribePopupInit) return;
    window.__subscribePopupInit = true;

    var settings = window.chewteinzSettings || {};

    if (
        typeof URLSearchParams !== "undefined" &&
        new URLSearchParams(window.location.search).has("subscribe_reset")
    ) {
        try {
            sessionStorage.removeItem("subscribe-modal-seen");
        } catch (e) {}
    }

    if (settings.subscribeModalEnabled === false) return;
    if (sessionStorage.getItem("subscribe-modal-seen")) return;

    var delaySeconds = parseInt(settings.subscribeModalDelaySeconds, 10);
    if (isNaN(delaySeconds) || delaySeconds < 0) delaySeconds = 10;
    var delayMs = delaySeconds * 1000;

    if (window.__subscribePopupTimer) {
        clearTimeout(window.__subscribePopupTimer);
    }

    function showSubscribePopup() {
        try {
            if (sessionStorage.getItem("subscribe-modal-seen")) return;
        } catch (e) {}
        if (!window.modals || typeof window.modals.openSubscribe !== "function") {
            return;
        }
        // Never open over a page the shopper isn't looking at - they'd come back
        // to a modal they never saw appear. Wait until the tab is visible again.
        if (document.hidden) {
            document.addEventListener("visibilitychange", function onShow() {
                if (document.hidden) return;
                document.removeEventListener("visibilitychange", onShow);
                showSubscribePopup();
            });
            return;
        }
        window.modals.openSubscribe();
    }

    window.__subscribePopupTimer = setTimeout(showSubscribePopup, delayMs);
}

// Safety net: if a modal ever ends up interactive while fully transparent, it is
// an invisible click-trap over the whole page. Put it back to sleep.
document.addEventListener(
    "click",
    function (e) {
        var modal = e.target.closest ? e.target.closest("[id$='-modal']") : null;
        if (!modal || modal.classList.contains("pointer-events-none")) return;
        if (parseFloat(getComputedStyle(modal).opacity) > 0.01) return;
        modal.classList.add("pointer-events-none", "opacity-0");
        modal.classList.remove("opacity-100");
        modal.setAttribute("aria-hidden", "true");
    },
    true,
);

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initSubscribeAutoPopup);
} else {
    initSubscribeAutoPopup();
}

// Contact form handler
function handleContactSubmit(e) {
    e.preventDefault();
    var form = document.getElementById("contact-form");
    var btn = document.getElementById("contact-submit-btn");
    var successEl = document.getElementById("contact-success");
    var errorEl = document.getElementById("contact-error");

    if (!form) return false;

    var name = document.getElementById("contact-name").value.trim();
    var email = document.getElementById("contact-email").value.trim();
    var subject = document.getElementById("contact-subject").value.trim();
    var message = document.getElementById("contact-message").value.trim();

    btn.textContent = "Sending...";
    btn.disabled = true;
    successEl.classList.add("hidden");
    errorEl.classList.add("hidden");

    var settings = window.chewteinzSettings || {};

    fetch(settings.makeWebhookUrl, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
            name: name,
            email: email,
            subject: subject,
            message: message,
        }),
    })
        .then(function (res) {
            if (!res.ok) throw new Error("Webhook failed");
            if (settings.supabaseUrl && settings.supabaseAnonKey) {
                return fetch(
                    settings.supabaseUrl + "/rest/v1/contact_submissions",
                    {
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            apikey: settings.supabaseAnonKey,
                            Authorization: "Bearer " + settings.supabaseAnonKey,
                        },
                        body: JSON.stringify({
                            name: name,
                            email: email,
                            subject: subject,
                            message: message,
                        }),
                    },
                ).catch(function () {});
            }
        })
        .then(function () {
            successEl.classList.remove("hidden");
            form.reset();
            btn.textContent = "Send Message";
            btn.disabled = false;
        })
        .catch(function () {
            errorEl.classList.remove("hidden");
            btn.textContent = "Send Message";
            btn.disabled = false;
        });

    return false;
}
